import { useState, useCallback } from 'react';

export const useSpamPrevention = () => {
    const [formLoadTime] = useState(() => Date.now());
    const [honeypot, setHoneypot] = useState('');

    const validateSubmission = useCallback((): { isValid: boolean; error?: string } => {
        // Check honeypot
        if (honeypot.trim() !== '') {
            return { isValid: false, error: 'Invalid submission' };
        }

        // Check timing (minimum 3 seconds)
        const submitTime = Date.now();
        if (submitTime - formLoadTime < 3000) {
            return { isValid: false, error: 'Please slow down' };
        }

        return { isValid: true };
    }, [honeypot, formLoadTime]);

    const HoneypotField = useCallback(() => (
        <input
            type="text"
            value={honeypot}
            onChange={(e) => setHoneypot(e.target.value)}
            style={{
                position: 'absolute',
                    left: '-9999px',
                    opacity: 0,
                    pointerEvents: 'none'
            }}
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
                />
        ), [honeypot]);

    return {
        HoneypotField,
        validateSubmission,
        formLoadTime,
    };
};